module.exports = __webpack_public_path__ + "open-sans-v17-latin-600.woff2?819af3d3abdc9f135d49b80a91e2ff4c";